const locale = {
    en: {
        // some basics
        'rooomguide.index': 'rooomGuide',
        'save': 'Save',
        'update': 'Update',
        'updating': 'Updating',
        'updated': 'Updated',
        // media types
        'type.image': 'Image',
        'type.audio': 'Audio',
        'type.video': 'Video',
        'type.panorama_image': 'Panorama Image',
        'type.panorama_video': 'Panorama Video',
        'type.chroma_video': 'Chroma Video',
        'type.three_dimensional_object': '3D Object',
        'type.marker': 'Marker',
        'type.waypoints': 'Waypoint',
        'form.upload': 'Upload',
        'media.select-from-library': 'Select from media library',
        'media.upload-new': 'Add Upload',
        'media.upload-file': 'Upload',
        'media.change-from': 'Change',
        'media.select-from': 'Load from Media',
        'type.three_dimensional_object_glb': 'GLB file',
        'type.three_dimensional_object_usdz': 'USDZ file',
        // tour
        'tour.index': 'Tours',
        'tour.visibile': 'Visible (set inisible)',
        'tour.invisible': 'Invisible (set visible)',
        'tour.publish': 'Publish',
        'tour.published': 'Published',
        'maps.no-key-present': 'No GoogleMaps API Key found.',
        'maps.consent-description': 'please allow us to load google maps for a better experience',
        'consent.for-now': 'consent for now',
        'consent.for-ever': 'consent for ever',
    }
}

function __(key, lang = 'en') {
    return locale[lang][key] || lang + '.' + key;
}

export { __ };
